import React from "react";

function Bowtie() {
  return (
    <>
      <path
        d="m 401.88069,515.30588 c -81.23785,48.30338 -213.68997,47.39367 -294.59951,-1.45762 16.27316,-19.14281 30.52283,-31.24812 39.20594,-37.3312 6.27235,-4.39728 12.84887,-8.34386 19.68,-11.81 l 2.31,-1.14 c 0.61,-0.32 1.24,-0.62 1.86,-0.92 5.25,-2.49 19.31,-5.71 31.11,-9.47 2.1,-0.66667 4.1,-1.33333 6,-2 v 0 c 4.53,-1.67 8.32,-3.45 10.47,-5.3 0.3301,-0.26781 0.63779,-0.56212 0.92,-0.88 0.53717,-0.62358 1.01899,-1.29278 1.44,-2 l 27.38,22.25 4.24,3.43 v 0 l 3.82,3.1 3.84,-2.59 4.69,-3.17 v 0 l 23.7,-16 h 0.05 l 10.6,-7.18 v 0 c 1.44515,1.80128 3.12703,3.39906 5,4.75 v 0 c 2.09782,1.5031 4.35068,2.77704 6.72,3.8 v 0 c 6.51,2.93 14.21,4.86 22.45,8.69 3.02,1.4 5.95333,2.85667 8.8,4.37 0.91,0.48 1.81,1 2.7,1.46 6.36289,3.47751 12.49253,7.36573 18.35,11.64 8.47688,6.09454 19.14582,14.176 39.26357,37.75882 z"
        style={{ fill: "#3586cb" }}
      />
      <path
        d="m 215.09712,425.48706 -16.62,7.92 a 4.6,4.6 0 0 0 -2.33,5.79 l 22.9,60.5 a 5,5 0 0 0 8.76,1.23 l 27.55,-36.91 c 0,0 -26.58,-29.21 -35,-37.64 a 4.6,4.6 0 0 0 -5.26,-0.89 z"
        style={{ fill: "#ffffff" }}
      />
      <path
        d="m 290.77712,426.37706 c -8.46,8.43 -35,37.64 -35,37.64 l 27.55,36.91 a 5,5 0 0 0 8.76,-1.23 l 22.91,-60.5 a 4.6,4.6 0 0 0 -2.33,-5.79 l -16.62,-7.92 a 4.6,4.6 0 0 0 -5.27,0.89 z"
        style={{ fill: "#ffffff" }}
      />
      <path
        d="m 265.93712,467.32706 a 15.53,15.53 0 0 0 -21,-0.16 l -29.64,-23.39 a 4.85,4.85 0 0 0 -7.85,3.81 v 62.31 a 4.85,4.85 0 0 0 7.85,3.81 l 29.66,-23.43 a 15.5,15.5 0 0 0 21,-0.16 l 29.87,23.55 a 4.85,4.85 0 0 0 7.85,-3.81 v -62.27 a 4.85,4.85 0 0 0 -7.85,-3.81 z"
        style={{ fill: "#db1b1b" }}
      />
    </>
  );
}

export default Bowtie;
